module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage6_m.3664eea0ee34b800ca237291ff666353.jpg";